import { GlobalNetworkAction, NetworkAction } from '../types';
import { MoveToActionHelper } from './specifics/move.to.action.helper';
import { BaseNetworkActionHelper } from './base.network.action.helper';
import { RemoteShellActionHelper } from './specifics/remote.shell.action.helper';
import { MegaMenuAction } from '../megaMenu/types';
import { AssignTagsActionHelper } from './specifics/assign.tags.action.helper';
import { UnassignTagsActionHelper } from './specifics/unassign.tags.action.helper';
import { SubmitToSandboxActionHelper } from './specifics/submit.to.sandbox.action.helper';
import { InstallAgentActionHelper } from './specifics/install.agent.action.helper';
import { DeleteActionHelper } from './specifics/delete.action.helper';
import { RemoveAdIntegratorActionHelper } from './specifics/remove.ad.integrator.action.helper';

export class NetworkActionsHelperFactory {
  public static getHelper(action: NetworkAction): BaseNetworkActionHelper {
    switch (action) {
      case MegaMenuAction.MOVE_TO:
        return new MoveToActionHelper();
      case GlobalNetworkAction.DELETE_ENTITY:
        return new DeleteActionHelper();
      case MegaMenuAction.INSTALL_AGENT:
        return new InstallAgentActionHelper();
      case MegaMenuAction.REMOTE_SHELL:
        return new RemoteShellActionHelper();
      case MegaMenuAction.ASSIGN_TAGS:
        return new AssignTagsActionHelper();
      case MegaMenuAction.UNASSIGN_TAGS:
        return new UnassignTagsActionHelper();
      case MegaMenuAction.SUBMIT_TO_SANDBOX:
        return new SubmitToSandboxActionHelper();
      case MegaMenuAction.REMOVE_AD_INTEGRATOR:
        return new RemoveAdIntegratorActionHelper();
      default:
        return new BaseNetworkActionHelper();
    }
  }
}
